enum SocketClientEvents {
  sendMessage = "sendMessage",
  readMessage = "readMessage",
  joinRoom = "joinRoom",
  createdRoom = "createdRoom",
  leaveRoom = "leaveRoom",
  disconnect = "disconnect",
  denialUpdated = "denialUpdated",
}

export default SocketClientEvents;
